import React, { useEffect, useMemo } from 'react';
import { Box, Container, Typography, Alert } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth } from '../hooks/useAuth';
import PageLayout from '../components/layout/PageLayout';
import { DashboardStatusCards } from '../components/dashboard';
import { parseDashboardOverview } from '../components/dashboard/dashboardHelpers';
import { getOverviewData, clearDashboardError } from '../store/slices/dashboardSlice';

const Dashboard = () => {
  const dispatch = useDispatch();
  const { user } = useAuth();
  const userName = user?.name;
  const overview = useSelector((state) => state.dashboard.overview);
  const loading = useSelector((state) => state.dashboard.loading);
  const error = useSelector((state) => state.dashboard.error);

  useEffect(() => {
    dispatch(getOverviewData());
    return () => {
      dispatch(clearDashboardError());
    };
  }, [dispatch]);

  const { role, sections } = useMemo(() => parseDashboardOverview(overview), [overview]);

  return (
    <PageLayout>
      <Container maxWidth="xl" sx={{ p: { xs: 2, sm: 3 } }}>
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" sx={{ fontWeight: 600, color: 'text.primary', mb: 0.5 }}>
            Welcome back, {userName || 'User'}!
          </Typography>
          {role && (
            <Typography variant="body1" color="text.secondary">
              {role} dashboard
            </Typography>
          )}
        </Box>

        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}

        {loading && !sections.length ? (
          <DashboardStatusCards loading />
        ) : (
          sections.map((section) => (
            <DashboardStatusCards
              key={section.key}
              title={section.title}
              items={section.items}
            />
          ))
        )}

        {!loading && !error && sections.length === 0 && (
          <Typography variant="body2" color="text.secondary">
            No dashboard data available for your role.
          </Typography>
        )}
      </Container>
    </PageLayout>
  );
};

export default Dashboard;
